var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cd-configurator-main", attrs: { id: "cd-configurator" } },
    [
      _c(
        "b-container",
        { staticClass: "cd-configurator-container" },
        [
          _c(
            "b-container",
            { staticClass: "stepper" },
            [
              _c("Stepper", {
                attrs: {
                  steps: _vm.maxProgress,
                  currentStep: _vm.currentProgress
                }
              })
            ],
            1
          ),
          _c(
            "b-container",
            { staticClass: "header" },
            [
              _c(
                "b-row",
                {},
                [
                  _c(
                    "b-col",
                    { attrs: { cols: _vm.isCompactLayout ? 10 : 12 } },
                    [
                      _c("div", { staticClass: "cd-progress" }, [
                        _vm._v(" " + _vm._s(_vm.progress) + " ")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: " d-header-section" },
                [
                  _c("b-col", { staticClass: "pt-0 col-12 col-md-10" }, [
                    _c("h3", { staticClass: "h3 font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.progressSubline) + " ")
                    ])
                  ]),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "col-12 col-md-2 p-0 m-0 d-flex justify-content-end"
                    },
                    [
                      _c("div", { staticClass: "d-none d-md-block" }, [
                        _c(
                          "p",
                          { staticClass: "cd-max-progress cd-primary-color" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.currentProgress) +
                                " / " +
                                _vm._s(_vm.maxProgress) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("hr"),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _vm.currentProgress < 7
                      ? _c("div", { staticClass: "cd-selection-text" }, [
                          _c(
                            "span",
                            { staticClass: "cd-current-selectiontext" },
                            [_vm._v(_vm._s(_vm.currentSelection))]
                          )
                        ])
                      : _vm._e(),
                    _vm.showEquipmentCompairsionLink
                      ? _c(
                          "div",
                          { staticClass: "cd-equipment-compairsion-link" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "cd-primary-color",
                                attrs: { href: "" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openEquipmentCompairsion()
                                  }
                                }
                              },
                              [_vm._v("Vergleichen")]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("Loader"),
          _vm.isCompactLayout ? _c("Sidebar") : _vm._e(),
          _vm.showCarInfo
            ? _c(
                "b-container",
                { attrs: { fluid: "", classs: "cd-car-info" } },
                [_c("CarInfo")],
                1
              )
            : _vm._e(),
          _c(
            "b-container",
            { staticClass: "cd-application-frame", attrs: { fluid: "" } },
            [_c("router-view")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }